import * as React from 'react';
import type { SVGProps } from 'react';
const SvgBigArrowIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={32}
    height={34}
    fill="none"
    viewBox="0 0 32 34"
    {...props}
  >
    <path
      fill="#212121"
      fillOpacity={0.5}
      d="M23.12 17.738c.1.976.973 1.708 1.95 1.636a1.716 1.716 0 0 0 1.592-1.895l-1.016-9.99A1.83 1.83 0 0 0 25 6.276a1.83 1.83 0 0 0-1.304-.425l-10.015.734c-.978.072-1.69.92-1.591 1.896s.972 1.708 1.95 1.636l5.74-.42L6.749 25.228c-.621.74-.507 1.859.254 2.498.762.639 1.883.556 2.504-.184l13.032-15.532z"
    />
  </svg>
);
export default SvgBigArrowIcon;
